import React, { useState } from "react";
import { Typography } from "antd";
import { ModalItem, ButtonItem } from "../../../../Components/Items";
import SelectorContactoItem from "./Selectores/SelectorContactoItem";
import ModalContacto from "../../CRM/Components/ModalContacto";
import { formatTelefono } from "../../../../Utils/whatsapp.utils";
import { WA } from "../theme";

const { Text } = Typography;

// Liga una conversación de WhatsApp sin contacto a un Contacto del CRM,
// eligiendo uno existente o creando uno nuevo al vuelo.
const ModalVincularContacto = ({
  visible,
  conversacion,
  headersToken,
  empresaId,
  onVincular,
  onCancel,
}) => {
  const [contacto, setContacto] = useState(null);
  const [modalContacto, setModalContacto] = useState(false);

  const handleCancel = () => {
    setContacto(null);
    onCancel();
  };

  if (!visible || !conversacion) return null;

  return (
    <>
      <ModalItem
        title="Vincular contacto"
        visible={visible}
        onCancel={handleCancel}
        footer={null}
        spinning={false}
      >
        <div style={{ marginBottom: 16 }}>
          <Text style={{ color: WA.textSecondary, fontSize: 13 }}>
            Vincula esta conversación ({formatTelefono(conversacion.telefono)})
            a un contacto del CRM para identificarla por su nombre.
          </Text>
        </div>
        <SelectorContactoItem
          headersToken={headersToken}
          empresaId={empresaId}
          value={contacto}
          onChange={setContacto}
        />
        <ButtonItem
          turquesa
          lessTime
          style={{ marginTop: 4 }}
          onClick={() => setModalContacto(true)}
        >
          + Crear contacto nuevo
        </ButtonItem>
        <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 16, gap: 8 }}>
          <ButtonItem onClick={handleCancel}>Cancelar</ButtonItem>
          <ButtonItem
            type="primary"
            lima
            disabled={!contacto}
            onClick={() => onVincular(contacto._id, handleCancel)}
          >
            Vincular
          </ButtonItem>
        </div>
      </ModalItem>

      <ModalContacto
        visible={modalContacto}
        idContacto={null}
        datosIniciales={{
          numero: String(conversacion.telefono || "").slice(-10),
          nombre: conversacion.nombrePerfilWa || undefined,
          origen: "WhatsApp",
        }}
        onCancel={() => setModalContacto(false)}
        onSuccess={(id) => {
          setModalContacto(false);
          if (id) onVincular(id, handleCancel);
        }}
      />
    </>
  );
};

export default ModalVincularContacto;
